import define from "./define";

const plan_postfix = " Plan";

export const general = {
  free: define.free,
  nonprofit: define.nonprofit,
  professional: define.professional,
  team: define.team,
  teamplus: define.teamplus,
  enterprise: define.enterprise,

  free_plan: define.free + plan_postfix,
  nonprofit_plan: define.nonprofit + plan_postfix,
  professional_plan: define.professional + plan_postfix,
  team_plan: define.team + plan_postfix,
  teamplus_plan: define.teamplus + plan_postfix,
  enterprise_plan: define.enterprise + plan_postfix,

  button_edit: "Edit",
  button_save: "Save",
  button_close: "Close",
  button_sign_out: "Log out",
  button_continue: "Continue",
  button_cancel: "Cancel",
  button_confirm: "Confirm",
  button_accept_all_cookies: "Accept all",
  button_accept_selected_cookies: "Accept selected",
  button_reject_cookies: "Reject non-required",
  button_show: "Show",
  button_hide: "Hide",

  loading: "Please wait...",
  discard_changes: "Discard changes?",

  form_error_required_template: "%s is a required field",
  form_error_template: "Field input has an error",

  
  network_error_general_head: "Unable to complete request",
  network_error_general:
    "We are having some unexpected troubles, please try again.",

  tagline_start: "Simplify app downloads\nwith",
  tagline_end: "all app stores",

  editor_tagline:
    "With onelink.to you get one link to your app instead on one link per app store.\nJust add each download URL (link) below and start use your onelink.to your app.",
  signup_now: "Sign up now",
  signup_now_free_free: "Sign up now - Start Free",

  error_unable_to_complete_request_head: "Unable to complete the request",
  error_unable_to_complete_request:
    "If the problem persist, please contact support@onelink.to",


  // DELETE ACCOUNT (COMPLETE REGISTRATION)
  account_deleted_head: "Account Deleted",
  account_deleted_info: "Your account is now deleted. You can create a new account at any time."


};
